"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderFormQuestionFileTargetEnum = void 0;
var OrderFormQuestionFileTargetEnum;
(function (OrderFormQuestionFileTargetEnum) {
    OrderFormQuestionFileTargetEnum["DOCUMENTATION"] = "documentation";
    OrderFormQuestionFileTargetEnum["CUSTOMER_DOCUMENTATION"] = "customer_documentation";
    OrderFormQuestionFileTargetEnum["CANCELLATION_DOCUMENTATION"] = "cancellation_documentation";
    OrderFormQuestionFileTargetEnum["CUSTOMER_SIGNOFF_FEEDBACK"] = "customer_signoff_feedback";
    OrderFormQuestionFileTargetEnum["CUSTOMER_BLUEPRINT"] = "customer_blueprint";
    OrderFormQuestionFileTargetEnum["PLANNING_PARTNER"] = "planning_partner";
    OrderFormQuestionFileTargetEnum["PLANNING_CUSTOMER"] = "planning_customer";
    OrderFormQuestionFileTargetEnum["EVU_REGISTRATION"] = "evu_registration";
})(OrderFormQuestionFileTargetEnum = exports.OrderFormQuestionFileTargetEnum || (exports.OrderFormQuestionFileTargetEnum = {}));
//# sourceMappingURL=order-form-question-file-target.js.map